module.exports = __webpack_public_path__ + "img/sfacg.29806fd5.png";